import Test from "../components/Learning/Test"
import useDoTestStore from "../store/testStore"
import ResultTest from "../components/Learning/ResultTest"
export default function DoTest () {
  const { result} = useDoTestStore()

  return (
    <div className="py-8 space-y-8">
         {
         result &&
         <ResultTest />
         }
          <Test />
        </div>
  )
}
